import CustomStore from 'devextreme/data/custom_store';
import { Http } from '@angular/http';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid } from './../app.config';
import { MotivoInativacao } from './motivo-inativacao.model';
import { NTECH_API } from '../app.api';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'ntc-motivo-inativacao',
  templateUrl: './motivo-inativacao.component.html',
  styleUrls: ['./motivo-inativacao.component.css']
})
export class MotivoInativacaoComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  listaMotivoInativacao: CustomStore;
  alturaGrid = null;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  colunasGridMotivoInativacao = [
    {
      dataField: 'Id',
      dataType: 'string',
      caption: 'ID',
      editorOptions: { disabled: true }
    },
    {
      dataField: 'DescricaoMotivoInativacao',
      dataType: 'string',
      caption: 'Descrição',
      validationRules: [{
        type: 'required',
        message: 'Descrição é obrigatório.'
      }]
    }
  ];

  editOptionsGridMotivoInativacao = {
    mode: GridConfig.gridMode,
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Motivo de Inativação',
      showTitle: true
    }
  };

  constructor(@Inject(Http) http: Http) {
    this.listaMotivoInativacao = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/motivo-inativacao/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/motivo-inativacao/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/motivo-inativacao/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/motivo-inativacao/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
  }
}



// WEBPACK FOOTER //
// ./src/app/motivo-inativacao/motivo-inativacao.component.ts